import React from "react";
import BillingCycleManagePage from "./BillingCycleManagePage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface BillingCycleManagePageContainerProps extends RouteProps, withValidUserRoleProps {}

const BillingCycleManagePageContainer = (props: BillingCycleManagePageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <BillingCycleManagePage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(BillingCycleManagePageContainer);
